import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { simpleVehicleGroupSchema } from '../schemas/vehicle-group.schema';

/**
 * Requests Vehicle Groups assigned to a specific Configuration Profile
 * @param id The ID of the Configuration Profile whose Vehicle Groups are being requested
 * @returns Array of Vehicle Groups being requested
 */
export function getConfigurationProfilesIdVehicleGroups(
  this: unknown,
  id: number
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .configurationProfilesIdVehicleGroupsUrl(id),
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(simpleVehicleGroupSchema),
      })
    )
  );
}
